import { render } from "./search-geo-content.vue?vue&type=template&id=a0d8e3d2"
import script from "./search-geo-content.js?vue&type=script&lang=js"
export * from "./search-geo-content.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__